<template>
  <page-header title="Payment Event Log" :identifier="id" />

  <div v-if="isLoaded" class="grid grid-cols-1 2xl:grid-cols-3 gap-2">
    <div class="bg-white shadow rounded-lg p-4 mb-6">
      <h2 class="text-xl font-semibold text-gray-700 border-b-2 border-primary-500 pb-1 mb-2">
        Event Information
      </h2>
      <div class="grid grid-cols-1 gap-2 text-sm">
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">ID:</span>
          <span class="text-gray-800 break-all font-mono text-xs">{{ log.id }}</span>
        </div>
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">Event Type:</span>
          <span class="text-gray-800 break-all">{{ log.eventType ?? '—' }}</span>
        </div>
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">Created At:</span>
          <span class="text-gray-800">{{ formatDateTime(log.createdAt) }}</span>
        </div>
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">Updated At:</span>
          <span class="text-gray-800">{{ formatDateTime(log.updatedAt) }}</span>
        </div>
      </div>
    </div>

    <div v-if="log.User" class="bg-white shadow rounded-lg p-4 mb-6">
      <h2 class="text-xl font-semibold text-gray-700 border-b-2 border-primary-500 pb-1 mb-2">
        User Information
      </h2>
      <div class="grid grid-cols-1 gap-2 text-sm">
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">User ID:</span>
          <span class="text-gray-800 break-all font-mono text-xs">{{ log.userId }}</span>
        </div>
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">Name:</span>
          <span class="text-gray-800">{{ log.User.name }}</span>
        </div>
        <div class="flex">
          <span class="font-bold text-gray-600 w-32">Email:</span>
          <span class="text-gray-800">{{ log.User.email }}</span>
        </div>
      </div>
    </div>

    <div v-if="log.payload" class="bg-white p-4 rounded-lg shadow">
      <h2 class="text-xl font-semibold text-gray-700 border-b-2 border-primary-500 pb-1 mb-2">
        Payload
      </h2>
      <div class="p-4 rounded-lg overflow-auto">
        <JSONView :data="log.payload" root-key="payload" />
      </div>
    </div>
  </div>

  <div v-else>
    Loading...
  </div>
</template>

<script setup>
import { ref } from 'vue';
import PageHeader from '../components/PageHeader.vue';
import { JSONView } from 'vue-json-component-vue-3';
import { useFetch } from '@vueuse/core';
import { apiDomain } from '../composables/useConstants';
import { formatDateTime } from '../utils/formatters';

const props = defineProps({
  id: {
    type: String,
    required: true
  }
});

const isLoaded = ref(false);
const log = ref({});

load();

async function load() {
  const { data } = await useFetch(`${apiDomain}/api/payment-event-log/${props.id}`).get().json();
  log.value = data.value;
  isLoaded.value = true;
}
</script>
